export const CHOOSE_COLLECTION = 'Выберите коллекцию';

export const MEASURE_ROOM = 'Измерьте помещение';

export const PLACE_ORDER = 'Оформите заказ';

export const ORDER_INSTALLATION = 'Закажите установку';
